import { Router } from '@angular/router';
import { ColumnOutputType } from '../../../../component-library/table/column-output-type';
import { TableColumn } from '../../../../component-library/table/table-column';
import { TableConfig } from '../../../../component-library/table/table-config';
import { AuthService } from '../../../../core/auth/auth.service';
import { CONFIG } from '../../../../core/config';
import { Widget } from '../../../../viewmodels/dashboard/widget';
import { WidgetParameter } from '../../../../viewmodels/dashboard/widget-parameter';
import { DisplayData } from '../bar/DisplayData';
import { RiskDistributionParameterType } from '../riskdistribution-parameter-type';
import { ViewDataTableService } from '../view-data-widget/view-data-table.service';
import { ValueSource } from '../widget-parameters/value-source.enum';
import { ValueType } from '../widget-parameters/value-type.enum';
import { ItemizedWidgetData } from './itemized-widget-data';

export class RiskDistributionItemizedWidgetData extends ItemizedWidgetData {
  public createTableConfig(): TableConfig {
    const tableConfig = super.initializeTableConfig();
    tableConfig.columns = this.createColumns();
    return tableConfig;
  }
  riskDistributionType: RiskDistributionParameterType;

  constructor(protected viewDataTableService: ViewDataTableService, protected router: Router, riskDistributionType: RiskDistributionParameterType, protected authService: AuthService) {
    super(viewDataTableService, router, authService);
    this.riskDistributionType = riskDistributionType;
  }

  public setFilterParameter(widget: Widget, widgetParam: WidgetParameter, reset: boolean) {
    const paramIndex = widget.widgetItemizedDataParameters.findIndex(w => w.valueSource === ValueSource.RiskDistributionEnum);

    if (paramIndex > -1) {
      if (!reset) {
        widget.widgetItemizedDataParameters[paramIndex] = widgetParam;
        return;
      }
      widget.widgetItemizedDataParameters.splice(paramIndex, 1);
      return;
    }
    if (!reset && widgetParam.valueSource === ValueSource.RiskDistributionEnum) {
      widget.widgetItemizedDataParameters.push(widgetParam);
    }
  }

  protected createColumns(): TableColumn[] {
    const assetNameColumn = new TableColumn('Asset Name', 'AssetName');
    assetNameColumn.outputType = ColumnOutputType.Link;
    assetNameColumn.linkClickEvent = this.navigateToHierarchyItem;
    const distributionType = new TableColumn(this.distributionTypeColumn(this.riskDistributionType), 'DistributionTypeValue');

    return [assetNameColumn, distributionType];
  }

  public createOverallTableHeaderColumn(): TableColumn {
    const headerColumn = new TableColumn(this.distributionTypeColumn(this.riskDistributionType), 'label');
    headerColumn.outputType = ColumnOutputType.Link;
    headerColumn.linkClickEvent = this.distributionTypeDrillDown;
    return headerColumn;
  }

  private distributionTypeDrillDown = (data: DisplayData) => {
    const widgetParam = new WidgetParameter();
    widgetParam.widgetId = data.widgetId;
    widgetParam.valueSource = ValueSource.RiskDistributionEnum;
    widgetParam.valueType = ValueType.String;
    widgetParam.displayName = data.label;
    widgetParam.stringValue = data.label;
    this.viewDataTableService.setItemizedDataWidgetParam.next(widgetParam);
  };

  private navigateToHierarchyItem = (data: any) => {
    if (data.HierarchyItemId) {
      this.router.navigate([this.authService.urlCatalog + CONFIG.routes.hierarchy.item.root(data.HierarchyItemId)]);
    }
  };

  private distributionTypeColumn(riskDistributionParameter: RiskDistributionParameterType): string {
    switch (riskDistributionParameter) {
      case RiskDistributionParameterType.RiskBand:
        return 'Risk';
      case RiskDistributionParameterType.Pof:
        return 'PoF';
      case RiskDistributionParameterType.Cof:
        return 'CoF';
      default:
        return 'Unknown';
    }
  }
}
